import type { NClientPayments } from '@app/types';

export const defaultSearchParams: NClientPayments.ModelOperationSearchFilter = {
  SearchTerm: null,
  DateS: new Date(
    new Date().setUTCDate(new Date().getUTCDate() - 1)
  ).toISOString(),
  DateE: new Date().toISOString(),
  ClientIds: null,
  UserIds: null,
  PaymentAccountIds: null,
  LegalEntityIds: null,
  PayTypes: null,
  ItemsPerPage: 20,
};
